import React from 'react';
import PropTypes from 'prop-types';

import {
    Button,
    Text,
    Spacer,
} from '@zillow/constellation';

import EditReviewResponse from 'app/shared/components/EditReviewResponse';

import ReviewsConstants from 'app/shared/constants/ReviewsConstants';
import format from 'date-fns/format';

import { StyledContainer } from './StyledComponents';

const propTypes = {
    review: PropTypes.shape({
        id: PropTypes.string.isRequired,
        reviewType: PropTypes.string.isRequired,
        reviewResponseId: PropTypes.string.isRequired,
        starLevel: PropTypes.number.isRequired,
        reviewMessage: PropTypes.string.isRequired,
        brand: PropTypes.string.isRequired,
        createdIsoString: PropTypes.string.isRequired,
        reviewResponseDateIsoString: PropTypes.string.isRequired,
        reviewResponseStatus: PropTypes.string.isRequired,
        responseMessage: PropTypes.string.isRequired,
    }).isRequired,
    onSubmitResponse: PropTypes.func.isRequired,
    onDeleteResponse: PropTypes.func.isRequired,
    canEdit: PropTypes.bool.isRequired,
};

const defaultProps = {
};

function formatDate(date) {
    return `${format(new Date(date), 'MMM D, YYYY')}`;
}

class Review extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEditing: false,
        };
        this.handleToggleEditing = this.handleToggleEditing.bind(this);
        this.handleSubmitResponse = this.handleSubmitResponse.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    handleDelete() {
        const { reviewResponseId, reviewType } = this.props.review;
        return this.props.onDeleteResponse(reviewResponseId, reviewType);
    }

    handleSubmitResponse(message) {
        const { id, reviewType, reviewResponseId } = this.props.review;
        return this.props.onSubmitResponse(id, reviewType, message, reviewResponseId)
            .then(() => this.setState({ isEditing: false }));
    }

    handleToggleEditing() {
        this.setState({ isEditing: !this.state.isEditing });
    }

    renderResponse() {
        const { review, canEdit } = this.props;
        const { responseMessage, reviewResponseStatus, reviewResponseDateIsoString } = review;
        return (
            <div>
                <Text fontType="body">{responseMessage}</Text>
                <Spacer paddingTop="xs">
                    {reviewResponseStatus === ReviewsConstants.RESPONSE_STATUS.OK ?
                        (
                            <Text fontType="body" fontColor="gray400">
                                {`Response posted on ${formatDate(reviewResponseDateIsoString)}`}
                            </Text>
                        ) : (
                            <Text fontType="bodyHeading">
                                Response is pending
                            </Text>
                        )
                    }
                </Spacer>
                {canEdit && (
                    <Spacer paddingTop="sm">
                        <Button
                            buttonType="primary"
                            onClick={this.handleToggleEditing}
                        >
                            Edit Response
                        </Button>
                    </Spacer>
                )}
            </div>
        );
    }

    renderForm() {
        const { responseMessage } = this.props.review;
        return (
            <EditReviewResponse
                mode="edit"
                initialMessage={responseMessage}
                onSubmit={this.handleSubmitResponse}
                onCancel={this.handleToggleEditing}
                onDelete={this.handleDelete}
            />
        );
    }

    render() {
        return (
            <StyledContainer>
                <Spacer padding="sm">
                    {this.state.isEditing ? this.renderForm() : this.renderResponse()}
                </Spacer>
            </StyledContainer>
        );
    }
}

Review.propTypes = propTypes;
Review.defaultProps = defaultProps;

export default Review;
